<template>
  <div>
    <a
      :class="$attrs.class"
      :style="$attrs.style"
      :href="$attrs.href"
      :title="$attrs.title"
    >
      <slot></slot>
    </a>
  </div>
</template>

<style scoped>
.icon-round {
  position: fixed;
  bottom: 2.5rem;
  width: 3.125rem;
  height: 3.125rem;
  display: block;
  cursor: pointer;
  z-index: 1000; /* Make sure it does not overlap */
  border: none; /* Remove borders */
  outline: none; /* Remove outline */
  color: #fff; /* Text color */
  cursor: pointer; /* Add a mouse pointer on hover */
  font-size: 1.8125rem;
  border-radius: 50%;
  text-align: center;
  align-self: center;
  background-color: #0d6efd;
  margin-bottom: 0.375rem;
}
.icon-round:hover,
.chat-zalo:hover,
.hotline-icon:hover {
  color: #0d6efd; /* Add a dark-grey background on hover */
  background-color: #555; /* Add a dark-grey background on hover */
}

.chat-zalo {
  position: fixed;
  border-radius: 0rem;
  padding: 0 0rem;
  margin-bottom: 0.375rem;
  bottom: 4.375rem;
  right: 1.25rem;
  display: block;
  cursor: pointer;
  z-index: 1000; /* Make sure it does not overlap */
  border: none; /* Remove borders */
  outline: none; /* Remove outline */
  color: #fff; /* Text color */
  cursor: pointer; /* Add a mouse pointer on hover */
  margin-bottom: 0.375rem;
}

.hotline-icon {
  position: fixed;
  bottom: 2.5rem;
  height: 2.1875rem;
  left: 1.875rem;
  padding: 0 0.3125rem;
  display: block;
  cursor: pointer;
  z-index: 1000; /* Make sure it does not overlap */
  border: none; /* Remove borders */
  outline: none; /* Remove outline */
  color: #fff; /* Text color */
  cursor: pointer; /* Add a mouse pointer on hover */
  font-size: 1.375rem;
  border-radius: 1.5625rem;
  font-weight: 400;
  text-transform: none;
  text-align: center;
  align-self: center;
  background-color: #f74b30;
  margin-bottom: 0.375rem;
}
</style>
